import type { MultiLangText } from "../store/types";

export interface CityConfig {
  id: string;
  name: MultiLangText;
  image: string;
}

/**
 * Static appearance config for cities.
 * Availability is derived at runtime from services.city_scope — not hardcoded here.
 */
export const CITY_CONFIG: CityConfig[] = [
  {
    id: "kyoto",
    name: { zh: "京都", en: "Kyoto", ja: "京都" },
    image:
      "https://public.readdy.ai/ai/img_res/0cf8c6c968b3a5ddc46adbaf1739d5cf.jpg",
  },
  {
    id: "osaka",
    name: { zh: "大阪", en: "Osaka", ja: "大阪" },
    image:
      "https://readdy.ai/api/search-image?query=Osaka%20Japan%20Dotonbori%20canal%20street%20scene%20soft%20evening%20light%20cinematic%20low%20saturation%20film%20photography%20aesthetic%20urban%20Japan%20tranquil%20moody%20atmosphere&width=800&height=800&seq=city-osaka-1&orientation=squarish",
  },
  {
    id: "tokyo",
    name: { zh: "東京", en: "Tokyo", ja: "東京" },
    image:
      "https://readdy.ai/api/search-image?query=Tokyo%20Japan%20Shinjuku%20quiet%20street%20scene%20soft%20morning%20light%20cinematic%20film%20grain%20aesthetic%20low%20saturation%20moody%20urban%20photography%20bokeh%20cherry%20blossom&width=800&height=800&seq=city-tokyo-1&orientation=squarish",
  },
];
